<template>
    <div slot="content">
        <div class="table-area">
            <div class="table-b">
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="grid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="columnDefs"
                        :grid-options="gridOptions"
                        :row-data="data"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReady"
                        @cell-clicked="onCellClicked" />
                </div>
            </div>
        </div>
        <!-- 모델정보 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">모델정보</h3>
                </div>
                <el-table
                    :data="tableModelInfo"
                    style="width: 100%">
                    <el-table-column
                    prop="makerNm"
                    label="제조사"
                    width="230">
                    </el-table-column>
                    <el-table-column
                    prop="modelGroupNm"
                    label="제품군"
                    width="220">
                    </el-table-column>
                    <el-table-column
                    prop="modelNm"
                    label="모델"
                    width="280">
                    </el-table-column>
                    <el-table-column
                    prop="serialNo"
                    label="제조번호"
                    width="140">
                    </el-table-column>
                    <el-table-column
                    prop="prodDt"
                    label="제조년월"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="purchaseDt"
                    label="구입년월"
                    width="100">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 모델정보 e. -->
        <!-- 장애내역 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">장애내역</h3>
                </div>
                <el-table
                    :data="tableTroubleData"
                    style="width: 100%">
                    <el-table-column
                    prop="breakGb"
                    label="증상구분"
                    width="160">
                    </el-table-column>
                    <el-table-column
                    prop="breakHst"
                    label="고장증상"
                    width="380">
                    </el-table-column>
                    <el-table-column
                    prop="breakDtl"
                    label="상세증상"
                    width="530">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 장애내역 e. -->
        <!-- 유/무상 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">유/무상</h3>
                </div>
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-form-item label="접수:">
                                <el-input v-model="payYnNm" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="처리:">
                                <el-select v-model="payYn" @change="onPayYnChange" disabled>
                                    <el-option
                                        v-for="item in payYnList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="변경사유">
                                <el-row>
                                    <el-col :span="24">
                                        <el-col :span="6">
                                            <el-select v-model="changePayYnCd" v-show="changePayYnCdShow" disabled>
                                                <el-option
                                                    v-for="item in changePayYnCdList"
                                                    :key="item.value"
                                                    :label="item.value"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                        <el-col :span="18">
                                            <el-input v-model="changePayYnMemo" readonly></el-input>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 유/무상 e. -->
        <!-- 접수/처리유형 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">접수/처리유형</h3>
                </div>
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-form-item label="접수:">
                                <el-input v-model="asClassNm" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="처리:">
                                <el-select v-model="changeAsClassCd" disabled>
                                    <el-option
                                        v-for="item in changeAsClassCdList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="변경사유">
                                <el-row>
                                    <el-col :span="24">
                                        <el-col :span="6">
                                             
                                        </el-col>
                                        <el-col :span="18">
                                            <el-input v-model="changeAsClassMemo" readonly></el-input>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 접수/처리유형 e. -->
        
        <!-- 고장원인 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">고장원인</h3>
                </div>
                <div class="btn-wrap btn-type1 clearfix">
                    <button class="btn-size btn-gray fl_right" v-show="showFailureCause" @click="failureCauseModal">
                    <span class="btn-icon">
                        <i class="fas fa-save"></i>
                    </span>
                    추가
                    </button>
                    <button class="btn-size btn-gray fl_right" v-show="showFailureCause" @click="deleteRow">
                    <span class="btn-icon">
                        <i class="fas fa-save"></i>
                    </span>
                    삭제
                    </button>
                </div>

                <!--
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="subGrid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="subColumnDefs"
                        :grid-options="subGridOptions"
                        :row-data="subData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReadySub"
                        />
                </div>
                -->

                <el-table
                    :data="tableFailureCause"
                    style="width: 100%">
                    <el-table-column
                    prop="asFailureCauseCat1"
                    label="원인구분"
                    width="200">
                    </el-table-column>
                    <el-table-column
                    prop="asFailureCauseCatNm"
                    label="원인명"
                    width="300">
                    </el-table-column>
                    <el-table-column
                    prop="description"
                    label="상세원인"
                    width="570">
                    </el-table-column>
                </el-table>
                
            </div>
        </div>
        <!-- 고장원인 e. -->

        <!-- 수리내역 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">수리내역</h3>
                </div>
                <el-table
                    :data="tableAsRepair"
                    style="width: 100%">
                    <el-table-column
                    prop="asRepairCat1"
                    label="증상구분"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="asRepairCat2"
                    label="고장증상"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="asRepairCat3"
                    label="고장부위"
                    width="170">
                    </el-table-column>
                    <el-table-column  v-if="bHidePrice"
                    prop="asRepairAmt"
                    label="기술료"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="description"
                    label="상세수리내역"
                    width="500">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 수리내역 e. -->

        <!-- 사용/회수자재 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">사용/회수자재</h3>
                </div>
                <el-table
                    :data="tableAsRepairItem"
                    style="width: 100%">
                    <el-table-column
                    prop="itemCd"
                    label="사용품번"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="itemNm"
                    label="사용품명"
                    width="200">
                    </el-table-column>
                    <el-table-column
                    prop="itemQty"
                    label="사용수량"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="90">
                    </el-table-column>
                    <el-table-column  v-if="bHidePrice"
                    prop="unitPrice3"
                    label="단가"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="100">
                    </el-table-column>
                    <el-table-column  v-if="bHidePrice"
                    prop="itemAmt3"
                    label="금액"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="recallItemCd"
                    label="회수품번"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="recallItemNm"
                    label="회수품명"
                    width="210">
                    </el-table-column>
                    <el-table-column
                    prop="recallItemQty"
                    label="회수수량"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="100">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 사용/회수자재 e. -->

        <!-- 교환모델 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">교환모델</h3>
                </div>
                <el-table
                    :data="tableChangeModel"
                    style="width: 100%">
                    <el-table-column
                    prop="changeModelNm"
                    label="모델"
                    align="center"
                    width="670">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.changeModelNm" size="small" controls-position="centor" :readonly="scope.row.readChangeModelNm" />
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="changeSerialNo"
                    label="제조번호"
                    align="center"
                    width="200">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.changeSerialNo" size="small" controls-position="centor" :readonly="scope.row.readChangeSerialNo" />
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="changeProdDt"
                    label="제조년월"
                    align="center"
                    width="200">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.changeProdDt" size="small" controls-position="centor" :readonly="scope.row.readChangeProdDt" />
                    </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 교환모델 e. -->

        <!-- 미처리사유 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">미처리사유</h3>
                </div>
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-form-item>
                                <el-select v-model="asStatus">
                                    <el-option
                                        v-for="item in asStatusList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="20">
                            <el-form-item>
                                <el-input v-model="asStatusMemo" readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 미처리사유 e. -->

        <!-- 특기사항, 수리비 s. -->
        <div class="talbe-contain" style="display: flex;">
            <div class="table-area" style="margin-right: 50px; width: 50%;">
                <div class="table-a">
                    <div class="table-name">
                    <h3 class="ico_table_name">특기사항</h3>
                    </div>
                    <el-form>
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <el-form-item>
                                    <el-input
                                        type="textarea"
                                        :readonly="readCatDescription"
                                        :autosize="{ minRows: 4, maxRows: 6}"
                                        placeholder="특기사항을 작성하세요."
                                        v-model="catDescription">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="table-area" style="margin-right: 50px; width: 50%;" v-show="$store.state.loginInfo.groupUId != '29'">
                <div class="table-a">
                    <div class="table-name">
                    <h3 class="ico_table_name">수리비</h3>
                    </div>
                    <el-table
                        :data="tableRepair"
                        style="width: 100%">
                        <el-table-column
                        prop="asItemUnitFee"
                        label="자재비"
                        header-align="left"
                        align="right"
                        :formatter="getElNumberFormat"
                        width="105">
                        </el-table-column>
                        <el-table-column
                        prop="asRepairFee"
                        label="기술료"
                        header-align="left"
                        align="right"
                        :formatter="getElNumberFormat"
                        width="105">
                        </el-table-column>
                        <el-table-column
                        prop="asRepairFeeAmt"
                        label="청구금액"
                        header-align="left"
                        align="right"
                        :formatter="getElNumberFormat"
                        width="105">
                        </el-table-column>
                        <el-table-column
                        prop="asRepairFeeAmtReal"
                        label="실청구금액"
                        header-align="left"
                        align="right"
                        :formatter="getElNumberFormat"
                        width="105">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- 특기사항, 수리비 e. -->

        <!-- 현장사진 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">현장사진</h3>
                </div>
                <el-table
                    :data="fieldImgList"
                    style="width: 100%;cursor: pointer;" 
                    @row-click="viewImg">
                    <el-table-column prop="originalName" label="파일명" align="center" width="230"> </el-table-column>
                    <el-table-column prop="downloadUrl" label="파일경로" align="center" width="600">
                        <template slot-scope="scope">
                            <el-tag
                            :type="scope.row.downloadUrl === '' ? 'primary' : 'success'"
                            disable-transitions>{{scope.row.downloadUrl}}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 현장사진 e. -->

        <div class="table-a">
        <el-form>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-button type="info" icon="el-icon-document" @click="openModal(0)" v-show="false">
                        불량판정서 출력
                    </el-button>
                </el-col>
            <!--
                <el-col :span="6">
                    <el-button type="info" icon="el-icon-document" v-show="showAsSaveValidate" @click="openModal(1)">
                        진행중
                    </el-button>
                </el-col>
                <el-col :span="6">
                    <el-button type="warning" icon="el-icon-edit-outline" v-show="showItemRequestValidate" @click="openModal(2)">
                        자재요청
                    </el-button>
                </el-col>
                <el-col :span="6">
                    <el-button type="danger" icon="el-icon-edit-outline" v-show="showAsCompleteValidate" @click="openModal(3)">
                        AS완료
                    </el-button>
                </el-col>
            -->
                <el-col :span="18" v-show="showAsCancel">
                    <el-col :span="12">
                        <el-form-item label="문자발송">
                            <el-radio-group v-model="smsYn">
                                <el-radio 
                                    v-for="item in smsYnRadio"
                                    :key="item.key"
                                    :label="item.key"
                                    :value="item.key">{{ item.value }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" icon="el-icon-folder-checked" @click="openModal(4)">
                            AS취소
                        </el-button>
                    </el-col>
                </el-col>
            </el-row>
        </el-form>
        </div>
    </div>
</template>

<script>
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

/**
 * * mixins
 */
 import lucoms from '@/mixin/lucoms';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
import DatepickerCellRenderer from '@/components/elementUI/datepicker-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import FailureCauseSelect from '@/components/LucomsModal/FailureCauseSelect.vue';
import FieldImgModal from '@/components/AS/History/Modal/ProcsHst/FieldImgModal.vue';
import ProductMenu from '@/components/AS/Receipt/Modal/ProductMenu.vue';
import DefectJudgmentModal from '@/components/AS/History/Modal/ProcsHst/DefectJudgmentModal.vue';

export default {
    mixins: [lucoms],
    components: {AgGridVue, DhxCalendar},
    data() {
        return {
            asId: '',
            data: [],
            subData: [], /** 고장원인 */
            value: 'test',
            textarea1: 'test area',
            listKey: '01',
            lists: [{key: '01', value: 'test'}],
            payYnNm: '', /** 유/무상 */
            payYn: '', /** 유/무상 */
            payYnList: [{key: '', value: ''}], /** 유/무상 */
            payYnIdList: [{key: '', value: ''}], /** 유/무상 */
            payYnLoadCnt: 0,
            changePayYnCdList: [{key: '', value: ''}], /** 유/무상 변경사유*/
            changePayYnCdShow: false,
            changePayYnCd: '',
            changePayYnMemo: '', /** 변경사유 메모 */ 
            asClassNm: '',    /** 접수명 */
            changeAsClassCd: '',    /** 접수/처리유형 변경사유 코드*/
            changeAsClassCdInit: '', /** 접수/처리유형 변경사유 코드*/
            changeAsClassCdList: [{key: '', value: ''}], /** 접수/처리유형 */
            changeAsClassMemo: '',  /** 접수/처리유형 변경사유 */
            asStatus: '', /** 미처리사유 */
            asStatusReal: '', /** 미처리사유(DB에 저장된 값) */
            asStatusList: [{key: '01', value: 'test'}],
            asStatusMemo: '', /** 미처리사유 */
            catDescription: '', /** 특기사항 */
            readCatDescription: true,
            selProcIdx: -1, /** 처리내역에서 선택된 Index 번호 */
            tabCacheLoadData: {},  /** tab을 클릭시 셋팅된 데이타 : AS접수모델 클릭시 재로딩하면 시간이 걸려서 캐싱하여서 로딩시키기 위해 */
            fieldImgList: [{fileNm: 'test1.jpg', savedFilePath: '/image/fieldimg/2023/img0001.jpg'}], /** 현장사진 */ 
            showFailureCause: false, /** 고장원인 추가/삭제 버튼 표시유무 */
            showAsSaveValidate: false, /** 진행중 */
            showItemRequestValidate: false, /** 자재요청 */
            showAsCompleteValidate: false, /** AS완료 */
            showAsCancel: false, /** AS취소 */
            bHidePrice: this.$store.state.loginInfo.groupUId =='29' ? false : true,
            smsYn: 'Y',
            smsYnRadio: [{key: 'Y', value: '발송'},{key: 'N', value: '미발송'}],
            
            tableModelInfo:[
                {
                    makerNm: '루컴즈11',
                    modelGroupNm: '루컴즈11',
                    modelNm: '루컴즈11',
                    serialNo: '루컴즈11',
                    prodDt: '루컴즈11',
                    purchaseDt: '루컴즈11'
            },],
            tableTroubleData: [/** 장애내역 */
                {
                breakGb: '증상구분',
                breakHst: '고장증상',
                breakDtl: '고장상세증상',
            },],
            tableFailureCause: [/** 고장원인 */
                {
                asFailureCauseCat1: '원인구분',
                asFailureCauseCatNm: '원인명',
                description: '상세원인명',
            },],
            tableAsRepair: [ /** 수리내역 */
                {
                asRepairCat1: '증상구분',
                asRepairCat2: '고장증상',
                asRepairCat3: '고장부위',
                asRepairAmt: '0',
                description: '상세수리내역'
            },],
            tableAsRepairItem: [ /** 사용/회수자재 */
                {
                 asRepairItemId: '', 
                 itemId: '', 
                 itemGroup: '',
                 itemGroupNm: '', 
                 useModelNm: '', 
                 itemCd: '', 
                 itemNm: '', 
                 itemQty: '', 
                 unitPrice3: '', 
                 itemAmt3: '', 
                 recallItemCd: '', 
                 recallItemNm: '', 
                 recallItemQty: ''
            },],
            tableChangeModel: [ /** 교환모델 */
                /*
                {
                    changeModelNm: '모델',
                    changeSerialNo: '제조번호',
                    changeProdDt: '제조년월',
                }
                */
            ],
            tableRepair: [ /** 수리비 */
                {
                asItemUnitFee: '자재비',
                asRepairFee: '기술료',
                asRepairFeeAmt: '청구금액',
                asRepairFeeAmtReal: '실청구금액'
            },],
             
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 0px; width: 100%;height: 200px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter: true
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            subColumnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                checkBox: CheckboxCellRenderer,
                input: InputCellRender,
            },
            //AG-GRID OPTION [END]
        }
    },
    watch: {
        payYnLoadCnt(){
            console.log('watch passed, ', this.payYnLoadCnt, this.changePayYnCd, this.changeAsClassCdInit)
            if(this.payYnLoadCnt === 2){
                /** 초기 로딩시에만 값 셋팅 */
                this.changePayYnCd = this.changeAsClassCdInit
            }
        }
    },
    mounted() {
        console.log('this.$parent: ', this.$parent)
        this.getCombo({flag: 'INIT'})
        this.$emit("loadTab", {"tabNm":"2", "index": 0})
        console.log('===mounted ====')
    },
    methods: {
        onReady() {
            
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();
            console.log('===onReady ====')
        },
        onReadySub() { 
            //고장원인 그리드 api 정의
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createSubColumnDefs();
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 유/무상 처리
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 353}}) // ChangePayYn
                    .then(response => {
                        this.payYnList = response.data || []
                        this.payYnLoadCnt++
                        console.log('payYnList data :', response.data )
                    });
                
                // 유/무상 처리
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 353}}) // ChangePayYn
                    .then(response => {
                        this.payYnIdList = response.data || []
                        this.payYnLoadCnt++
                        console.log('payYnList data2 :', response.data )
                    });    
    
                // 접수/처리유형     
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 344}}) // ChangeAsClass
                    .then(response => {
                        this.changeAsClassCdList = response.data || []
                    });
                
                // 미처리사유
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 385}}) // AsStatus
                    .then(response => {
                        this.asStatusList = response.data || []
                    });

            } else {
                console.log('getCombo aaa=== ', param)
                if(param.parentId === ''){
                    this.changePayYnCdShow =  false
                } else{
                    this.changePayYnCdShow =  true

                    // 변경사유
                    this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                        .then(response => {
                            this.changePayYnCdList = response.data || []
                            this.changePayYnCdList.unshift({key:'', value:'전체'})
                            this.changePayYnCd = ''
                    });
                }
            } 
                
        },
        createColumnDefs() {
            this.columnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:50,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    },
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName:'순번',
                    field:'no', 
                    width:80,
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:140,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width:180,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width:180,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    },
                    cellRenderer: (params) => {
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    }
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width:130,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'구입년월',
                    field:'purchaseDt', 
                    width:130,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'datePicker',
                    cellRendererParams: {
                        // 참고 문서 : https://element.eleme.io/#/en-US/component/date-picker#attributes
                        type: 'month',
                        format: 'yyyy-MM',  //date format
                        valueFormat: 'yyyyMM',  //받는 model 의 결과 포맷
                        disable: true, //disabled 처리
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
            ];
        },
        createSubColumnDefs() {
            this.subColumnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName: '원인구분', 
                    field:'gbCd', /** 카테고리3레벨 */
                    width: 130,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '원인명', 
                    field:'gbNm', /** 카테고리4레벨 */
                    width: 250,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '상세원인명',
                    field:'description', 
                    width: 550,
                    cellRenderer: 'input',
                    cellStyle:{textAlign:'left'},
                    cellRendererParams: {
                        obj: {
                            placeholder: "상세원인을 입력하세요."
                        }
                    }
                },
                {
                    headerName: 'AS_CAT_ID', 
                    field:'asCatId',
                    hide: true,
                    suppressToolPanel: true
                }
            ];
        },
        changeProcsHstInfo(param, index){
            console.log('ProcsHst changeProcsHstInfo start param : ', param)
            this.tabCacheLoadData = param;
            
            this.asId = param.asId || '';
            const vAsDetailId = param.asDetailId || '';
            const vAsProcessId = param.asProcessId || '';
            console.log('ProcsHst changeProcsHstInfo start vAsDetailId : ', vAsDetailId, vAsProcessId)
            if(vAsDetailId === '') return false;

            if(param.callAsProcessSel1List){
                let vProdDt = param.callAsProcessSel1List[index].prodDt
                if(vProdDt && vProdDt.length > 10 ){
                    vProdDt = vProdDt.substring(0, 10)
                }

                let vPurchaseDt = param.callAsProcessSel1List[index].purchaseDt
                if(vPurchaseDt && vPurchaseDt.length > 10 ){
                    vPurchaseDt = vPurchaseDt.substring(0, 10)
                }

                // 모델정보
                this.tableModelInfo = param.callAsProcessSel1List
                    .filter(x=>x.asDetailId===vAsDetailId && x.asProcessId===vAsProcessId)
                    .map(y=>{
                        return {
                                makerNm : y.makerNm,
                                modelGroupNm : y.modelGroupNm,
                                modelNm: y.modelNm,
                                serialNo: y.serialNo,
                                prodDt: y.prodDt && y.prodDt.length>=10 ? y.prodDt.substring(0,10): '',
                                purchaseDt: y.purchaseDt && y.purchaseDt.length>=10 ? y.purchaseDt.substring(0,10): ''
                            };
                    }) || [];

            }

            // 장애내역
            this.tableTroubleData = param.callAsCat
                .filter(x=>x.asDetailId==vAsDetailId)
                .map(y => { 
                    let arrCat = y.asCatFullNm.split('>');
                    if(arrCat){
                        if(arrCat.length >= 2){
                            y.breakGb = arrCat[1] ;
                        }
                    }
                    y.breakHst = y.asCatNm;
                    y.breakDtl = y.description;
                    return y;
                });

            if(param.callAsDetail && param.callAsDetail.length>=index){
                // 유/무상 : AS_DETAIL
                // 선택한 모델ROW에서 asDetailId 와 같은 접수건의 모델을 찾는다.
                // 동일한 접수번호(asDetailId)에 대해서 동일한 접수상태로 처리한다.
                const vDetailObj = param.callAsDetail.filter(x=>x.asDetailId == param.asDetailId);
                if(vDetailObj && vDetailObj.length>0){
                    let changePayYnObj = param.getCatDataByParent.filter(x => x.topKey === 'ChangePayYn' 
                                                                && x.catKey === vDetailObj[0].payYn) || [];
                    this.payYnNm = changePayYnObj[0].catNm || ''; // 유/무상
                }
            }
            
            let vChkCallAsProcessMstSelList = false
            if(param.callAsProcessMstSelList && param.callAsProcessMstSelList.length>0){
                vChkCallAsProcessMstSelList = true
            }

            if(param.callAsProcessSel1List && param.callAsProcessSel1List.length>=index){
                this.payYn = param.callAsProcessSel1List[index].payYn || 'Y'
                this.changePayYnMemo = param.callAsProcessSel1List[index].changePayYnMemo || ''
            }
            
            // 접수/처리유형
            this.asClassNm = param.callAsDetail[0].asClassNm || '' //접수
            
            if(vChkCallAsProcessMstSelList){
                this.changeAsClassCd = param.callAsProcessMstSelList[0].changeAsClassCd || '' //변경사유 코드
                this.changeAsClassCdInit = this.changeAsClassCd
                this.changeAsClassMemo = param.callAsProcessMstSelList[0].changeAsClassMemo || '' //변경사유 메모
            }

            // 고장원인
            this.tableFailureCause = param.callAsFailureCause.filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId) || []
            
            // 수리내역
            this.tableAsRepair = param.callAsRepair
                                    .filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId)
                                    .map(y=>{
                                        if(this.payYn !== 'Y'){
                                            // 무상이면 기술료 0
                                            y.asRepairAmt = '0';
                                        }
                                        
                                        return y;
                                    }) || [] ;
             
            // 사용/회수자재
            this.tableAsRepairItem = param.callAsRepairItem.filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId) || []
            if(this.payYn === 'N'){
                // 무상이면 금액을 0
                this.tableAsRepairItem.map((x, i) => {
                    x.itemAmt3 = 0
                    return x
                })
            }
            
            // 접수/처리유형에서 처리가 제품교환인 경우
            const isExchange = this.changeAsClassCd === 'Exchange' ? true : false
            
            // 교환모델
            if(vChkCallAsProcessMstSelList){
                // 첫번째 ROW만 표시
                this.tableChangeModel = [param.callAsProcessMstSelList[0]]
            }

            if(this.tableChangeModel && this.tableChangeModel.length > 0){
                if(isExchange){
                    this.tableChangeModel[0].readChangeModelNm = false
                    this.tableChangeModel[0].readChangeSerialNo = false
                    this.tableChangeModel[0].readChangeProdDt = false
                    
                } else {
                    this.tableChangeModel[0].readChangeModelNm = true
                    this.tableChangeModel[0].readChangeSerialNo = true
                    this.tableChangeModel[0].readChangeProdDt = true
                }
            }
            
            
            //changeModelNm changeSerialNo changeProdDt
           
            // 미처리사유
            this.asStatusReal = param.callAsMstSelList[0].asStatus || ''
            this.asStatus = this.asStatusReal
            if(this.asStatus.length > 1 ){
                // 실제 진행상태('Square','Confirm','Complete','Receipt','Return')의 값이 있는 경우 공백처리
                this.asStatus = ''
            }

            // 미처리사유 메모
            this.asStatusMemo = param.callAsMstSelList[0].asStatusMemo || ''
            
            // 특기사항
            this.catDescription = param.callAsMstSelList[0].description || ''

            // 수리비
            this.tableRepair = [
                {
                asItemUnitFee: param.callAsMstSelList[0].asRepairUnitFee || '', /** 자재비 */
                asRepairFee: param.callAsMstSelList[0].asRepairFee || '', /** 기술료  asRepairFee > asRepairPrice */
                asRepairFeeAmt: param.callAsMstSelList[0].asRepairFeeAmt || '', /** 청구금액 */
                asRepairFeeAmtReal: param.callAsMstSelList[0].asRepairFeeAmtReal || '' /** 실청구금액 */
            },]
            
            // 현장사진
            //this.fieldImgList = param.callFieldImgList || [];
            this.$store.commit('loading');
            this.$http.post(`/api/mobile/asMng/picture/files/${this.asId}/${vAsProcessId}/${vAsDetailId}`)
            .then(res => {
                this.fieldImgList = res.data || [];
            })
            .catch(e => {
                this.$swal({ type: 'warning', text: `${e.message}` });
            })
            .finally(() => {
                this.$store.commit('finish');
            })
            

            /** 선택한 모델에 해당하는 처리내역 조회 : ASIS함수(btnAsProcessTab_AsProcessSelect_Click) */
            
            // this.$store.commit('loading')
            // this.$http.post(_url("/api/asMng/popup/asRead/getAsProcessId"), {
            //     companyId: 'CENTERLINK', //this.$store.state.loginInfo.compCd,
            //     asId: asId,
            //     asProcessId: asProcessId
            // }).then(response => {
            //      console.log('response.data' , response.data)
                 
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            const vSqObj = param.callAsMstSelList[0]
            const vAstatus = vSqObj ? vSqObj.asStatus : ''

            // 접수관리 : 6
            const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===6)
console.log('auth: ', auth )

            let GrantCancel = false // 취소권한
            if(auth && auth.length > 0){
                GrantCancel = auth[0].grantExtend1 === 'Y' ? true : false   
            }
            const AsProcessCancelable = (GrantCancel && vAstatus === 'Receipt') ? true : false
            this.showAsCancel = AsProcessCancelable // AS취소 버튼
            this.readCatDescription = !this.showAsCancel /** 특기사항 */
        
            // showAsSaveValidate: true, /** 진행중 */
            // showItemRequestValidate: true, /** 자재요청 */
            // showAsCompleteValidate: true, /** AS완료 */
            // showAsCancel: true, /** AS취소 */

            const vAsProcessEditable = false
            this.showFailureCause = vAsProcessEditable
           
            if(vAstatus === 'Receipt'){
            
            } else if(vAstatus === 'Processing'){

            } else if(vAstatus === 'Suspension'){

            } else if(vAstatus === 'Return'){

            } else if(vAstatus === 'Complete'){
                
            } else if(vAstatus === 'Confirm'){
                
            } else if(vAstatus === 'Square'){
                
            }

        },
        onCellClicked(params, rowIdx) {
            /** 모델을 선택한 경우에 해당하는 처리내역을 호출하도록 함.*/

            console.log('onCellClicked params: ', params)
            const idx = params.rowIndex;
            const field = params.colDef.field;
            this.selProcIdx = idx;

            // 로딩속도 개선 : 직접호출시 속도가 늦음. 이미 로딩된 캐싱을 이용해서 2번 방법 사용.
            // 1. 직접호출
            //this.$emit("loadTab", {"tabNm":"2", "index": idx, "asDetailId": params.data.asDetailId, "asProcessId": params.data.asProcessId })
            
            // 2. 캐싱 사용
            this.tabCacheLoadData.asDetailId = params.data.asDetailId;
            this.tabCacheLoadData.asProcessId = params.data.asProcessId;
            this.changeProcsHstInfo(this.tabCacheLoadData, idx);
            this.gridApi.redrawRows({ rowNodes: params });

            if(field === 'modelNm') {
                this.openModelSpec(params.data);
            }

            // this.data = this.data.map((x, i) => {
            //     if(idx === i) {
            //         if(x.chk === 'Y') {
            //             return x;
            //         } else {
            //             x.chk = x?.chk !== 'Y' ? 'Y' : 'N';
            //         }
            //     } else {
            //         if(x.chk === 'Y') {
            //             x.chk = x?.chk !== 'N' ? 'N' : 'Y';
            //         } else {
            //             return x;
            //         }
            //     }
            //     return x;
            // })
            
        },
        onPayYnChange(value){
            /** 유/무상 > 처리 */
            //console.log('onPayYnChange start====', value)
            /** 변경사유select 재로딩처리 */

            const vPayYnIdx = this.payYnList.findIndex(x=>x.key === value)
            const vParentId = this.payYnIdList[vPayYnIdx].key || 0

            this.getCombo({flag: '', parentId: vParentId})
        },
        openModal(idx) {
            let vm = this;
                
            if(idx === 0){
                // 불량판정서 출력
                
                this.$modal.open({
                    width: 950,
                    component: DefectJudgmentModal,
                    parent: this,
                    props: {
                        data: {
                            test: 'test'
                        }
                    },
                    events: {
                        close(data) {
                            console.log('close', data);
                        },
                    }
                });

            } else if(idx === 4){
                // AS취소
                if(this.catDescription === ''){
                    this.$swal({type: 'warning', text: '특기사항에 AS 취소 사유를 입력해주십시오.'});
                    return false;
                }

                const vSaveform ={
                    smsYn: this.smsYn,
                    asId: this.asId || '',
                    description: this.catDescription || ''
                };
                console.log('vSaveform: ', vSaveform);
                this.$swal({
                    type: 'warning',
                    text: `AS를 취소하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$store.commit('loading');
                        this.$http.put(_url("/api/asMng/call/saveCancelAs"), vSaveform)
                            .then(response => {
                                this.$swal({ type: 'success', text: 'AS취소 처리되었습니다.' });
                                
                            }).catch((e) => {
                                console.error(e);
                                this.$swal({ type: 'success', text: 'AS취소에 실패 했습니다.' });
                            })
                            .finally(() => {
                                this.$store.commit('finish');
                            });
                    }
                });

            }
            // const components = [{
            //     key: 1, component: RepairHst, width: 1000,data: {},
            // }, {
            //     key: 2, component: PayChange, width: 1000, data: {}
            // }, {
            //     key: 3, component: BillAmtChange, width: 100, data: {billAmt: 10000}
            // }];
            // const {component, data, width} = components.filter(x => x.key === idx)[0];
            // console.log(component, data, width)
            // this.$modal.open({
            //     width: width,
            //     component: component,
            //     parent: this,
            //     props: {
            //         data
            //     },
            //     events: {
            //         close(data) {
            //             console.log('close', data);
            //         },
            //     }
            // });
        },
        failureCauseModal(){
            const vm = this
            const vSelModelObj ={}

            // 고장원인 추가
            this.$modal.open({
                component: FailureCauseSelect,
                parent: this,
                props: {
                    data: {
                        selModelObj: vSelModelObj
                    },
                },
                events: {
                    close(param) {
                        console.log('close', param);
                        if(param.data){
                            vm.subData = vm.subData ? vm.subData : []

                            param.data.forEach(x => {
                                const chkObj = vm.subData.filter(y=>y.asCatId===x.asCatId)
                                if(chkObj && chkObj.length>0 ){
                                    // skip
                                } else {
                                    const tmp = {
                                        chk: 'Y',
                                        asCatId: x.asCatId,
                                        gbCd: x.gbCd,
                                        gbNm: x.gbNm,
                                        description: ''
                                    }
                                    vm.subData.push(tmp)
                                }
                            })

                        }
                    },
                }
            });

        },
        deleteRow(){
            // 고장원인 삭제
            let vSrcObj = this.subData
            let chkedObj = vSrcObj.filter(x=>x.chk==='Y')

            if(!vSrcObj || chkedObj.length === 0){
                this.$swal({
                type: 'warning',
                text: '선택된 행이 없습니다.'
                });

                return false
            }

            this.subData = vSrcObj.filter(x=>x.chk!='Y')
 
        },
        viewImg(row, column, event){
            console.log('viewImg column :', row, column)
            this.openFieldImgModel(row);
        },
        openFieldImgModel(param) {
            /** 현장사진 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: FieldImgModal,
                parent: this,
                props: {
                    imgobj: param || []
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        /**
         * 모델 사양 팝업 오픈
         * * 그리드 상 모델 선택시 오픈되어지는 모델 사양
         */
         openModelSpec(param) {
            
            const vForm = {
                modelGroup: param.modelGroup,
                modelCd : param.modelNm
            };

            this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {data: vForm}});
        }
    }
}
</script>